import { render, staticRenderFns } from "./SumaryTableOfMatters.vue?vue&type=template&id=ce005e00&scoped=true"
import script from "./SumaryTableOfMatters.vue?vue&type=script&lang=js"
export * from "./SumaryTableOfMatters.vue?vue&type=script&lang=js"
import style0 from "./SumaryTableOfMatters.vue?vue&type=style&index=0&id=ce005e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce005e00",
  null
  
)

export default component.exports